var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"elevation-1 mb-6"},[_c('v-card-title',{staticClass:"pa-7"},[_vm._v(" Přehled uživatelů "),_c('v-spacer',{staticClass:"mb-10"})],1),_c('v-card-text',[_c('UsersFilters',{on:{"filter":_vm.setFiltersAction}}),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.userHeadersByRole,"items":_vm.user.items,"options":_vm.user.options,"server-items-length":_vm.user.serverItemsLength,"loading":_vm.user.loading,"item-key":"id"},on:{"update:options":function($event){return _vm.$set(_vm.user, "options", $event)}},scopedSlots:_vm._u([{key:"item.customer.id",fn:function(ref){
var item = ref.item;
return [(item.customer)?_c('router-link',{attrs:{"to":{
              name: 'customers.detail',
              params: {
                customerId: item.customer.id,
              },
            }}},[_vm._v(" "+_vm._s(item.customer.id)+" ")]):_vm._e()]}},{key:"item.id",fn:function(ref){
            var item = ref.item;
return [(item.customer)?_c('router-link',{attrs:{"to":{
              name: 'customers.detail',
              params: {
                customerId: item.customer.id,
              },
            }}},[_vm._v(" "+_vm._s(item.id)+" ")]):_c('span',[_vm._v(" "+_vm._s(item.id)+" ")])]}},{key:"item.createdAt",fn:function(ref){
            var item = ref.item;
return [_c('DateTime',{attrs:{"datetime":item.createdAt,"single-line":false}})]}},{key:"item.role",fn:function(ref){
            var item = ref.item;
return [_c('UserRole',{attrs:{"role":item.role}})]}},{key:"item.status",fn:function(ref){
            var item = ref.item;
return [_c('UserStatus',{attrs:{"status":item.status}})]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }